import styled from '@emotion/styled';
import React from 'react';
import Colors from '../../components/theme/colors';

const NavbarSection = ({ ...props }) => {
  return (
    <LayoutRoot {...props}>
      <MainContainer>
        <Image
          src="/logo.png"
          alt="Oncohost Logo"
          onClick={() => (window.location.href = 'https://www.oncohost.com')}
        />
      </MainContainer>
    </LayoutRoot>
  );
};

export default NavbarSection;

const LayoutRoot = styled.section`
  width: 100%;
  padding: 24px 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${Colors.gray_1};
  -webkit-print-color-adjust: exact;

  @media (max-width: 1044px) {
    padding: 20px 16px;
  }
`;

const MainContainer = styled.div`
  display: flex;
  justify-items: flex-start;
  width: 100%;
  max-width: 1612px;

  @media (max-width: 1044px) {
    max-width: none;
  }
`;

const Image = styled.img`
  height: 46px;
  cursor: pointer;
`;
